import React, { useState, useEffect } from 'react';
import { useData } from '../../../context/DataContext';
import SafeIcon from '../../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import ResultsList from '../../Search/ResultsList';

const { FiSearch, FiX, FiChevronDown, FiUpload } = FiIcons;

/**
 * Vista de Inventario optimizada.
 * Reemplaza SearchTab para ser más ligero y estable.
 */
const InventoryView = ({ onOpenImporter }) => {
  const [query, setQuery] = useState('');
  const [filters, setFilters] = useState({ wardrobeName: '', locker: '' });
  const { searchInventory, getUniqueWardrobes, getLockersByWardrobe, inventoryData } = useData();

  const uniqueWardrobes = getUniqueWardrobes();
  const lockers = filters.wardrobeName ? getLockersByWardrobe(filters.wardrobeName) : [];

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      ...(key === 'wardrobeName' ? { locker: '' } : {})
    }));
  };

  const results = searchInventory(query, filters);

  return (
    <div className="space-y-6">
      {/* Panel de Control */}
      <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 space-y-4">
        {/* Buscador Principal */}
        <div className="relative">
          <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input 
            type="text" 
            value={query} 
            onChange={(e) => setQuery(e.target.value)} 
            placeholder="Buscar por nombre o código..." 
            className="w-full pl-11 pr-10 py-3 bg-gray-50 border-transparent border rounded-xl focus:bg-white focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all outline-none text-sm" 
          />
          {query && (
            <button onClick={() => setQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-gray-400">
              <SafeIcon icon={FiX} />
            </button>
          )}
        </div>

        {/* Selectores de Filtro */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="relative">
            <select 
              value={filters.wardrobeName} 
              onChange={(e) => handleFilterChange('wardrobeName', e.target.value)}
              className="w-full pl-4 pr-10 py-2.5 bg-gray-50 border-transparent rounded-xl appearance-none focus:ring-2 focus:ring-red-500 outline-none text-sm cursor-pointer"
            >
              <option value="">Todos los vestuarios</option>
              {uniqueWardrobes.map(w => <option key={w} value={w}>{w}</option>)}
            </select>
            <SafeIcon icon={FiChevronDown} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
          </div>

          <div className="relative">
            <select 
              value={filters.locker} 
              onChange={(e) => handleFilterChange('locker', e.target.value)}
              disabled={!filters.wardrobeName}
              className="w-full pl-4 pr-10 py-2.5 bg-gray-50 border-transparent rounded-xl appearance-none focus:ring-2 focus:ring-red-500 outline-none text-sm cursor-pointer disabled:opacity-50"
            >
              <option value="">Todas las taquillas</option>
              {lockers.map(l => <option key={l} value={l}>{l}</option>)}
            </select>
            <SafeIcon icon={FiChevronDown} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
          </div>
        </div>

        {/* Botón de Importación (Solo si no hay datos) */}
        {inventoryData.length === 0 && (
          <button 
            onClick={onOpenImporter}
            className="w-full py-3 bg-blue-50 text-blue-600 rounded-xl font-bold flex items-center justify-center space-x-2 border border-blue-100 hover:bg-blue-100 transition-colors"
          >
            <SafeIcon icon={FiUpload} />
            <span>Importar Datos desde Excel</span>
          </button>
        )}
      </div>

      {/* Listado de Resultados */}
      <div className="pb-10">
        <div className="flex items-center justify-between mb-4 px-1">
          <h2 className="text-lg font-bold text-gray-800">
            {results.length > 0 ? `Resultados (${results.length})` : 'Sin resultados'}
          </h2>
        </div>
        <ResultsList results={results} />
      </div>
    </div>
  );
};

export default InventoryView;